import React, { useId } from 'react';

import { Typography } from 'antd';

import SectionStatusContent, { type SectionStatus } from '../SectionStatus';
import styles from './styles.module.less';

const { Text, Title } = Typography;

export interface ReportSectionProps {
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
  headerExtra?: React.ReactNode;
  /** Load state of the content; the heading stays visible in every state. */
  status?: SectionStatus;
}

/** Card with a title, a short description and optional header controls. */
const ReportSection: React.FC<ReportSectionProps> = ({
  title,
  description,
  children,
  className,
  headerExtra,
  status,
}) => {
  const titleId = useId();

  return (
    <section
      className={`${styles.section} ${className ?? ''}`}
      aria-labelledby={titleId}
      aria-busy={status?.kind === 'loading'}
    >
      <div className={styles.headingRow}>
        <div className={styles.heading}>
          <Title level={5} id={titleId}>
            {title}
          </Title>
          <Text type="secondary">{description}</Text>
        </div>
        {headerExtra}
      </div>
      <SectionStatusContent status={status}>{children}</SectionStatusContent>
    </section>
  );
};

export default ReportSection;
